var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccessBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Payment_Success",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8137",
    fill: "#15cf62",
    d: "M99.138 167.4a44 44 0 1 0 44 44 44 44 0 0 0-44-44zm18.223 34.268l-22.628 22.627a2.5 2.5 0 0 1-3.535 0l-9.328-9.328a2.5 2.5 0 0 1 3.535-3.535l7.561 7.56 20.86-20.86a2.5 2.5 0 1 1 3.535 3.535z",
    "data-name": "Path 8137",
    transform: "translate(-55.138 -167.399)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessBig);
export default __webpack_public_path__ + "static/media/icon_success_big.fe0a4db39bd71addb5f3d839aa9fb176.svg";
export { ForwardRef as ReactComponent };